"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAssets = void 0;
const helpers_1 = require("../helpers");
function loadAssets({ contents, scale }, assetCache) {
    const loadPromises = contents
        .filter((content) => content.type === 'image' && !!content.image.url)
        .map(content => {
        const contentImage = content.image;
        const scaledImage = (0, helpers_1.sizeImage)(contentImage.clippingMask.width, contentImage.clippingMask.height, content.width * scale, content.height * scale);
        const width = scaledImage.width * contentImage.width / contentImage.clippingMask.width;
        const height = scaledImage.height * contentImage.height / contentImage.clippingMask.height;
        return !assetCache.hasImage(contentImage.url, { width, height })
            ? assetCache.loadImage(contentImage.url, { width, height })
            : null;
    })
        .filter((promise) => promise !== null);
    return {
        loaded: loadPromises.length === 0,
        loadPromise: Promise.all(loadPromises),
    };
}
exports.loadAssets = loadAssets;
